"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactDnd = require("react-dnd");

var _underscore = require("underscore");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIUnstyledButton = _interopRequireDefault(require("UIComponents/button/UIUnstyledButton"));

var _UIDragHandle = _interopRequireDefault(require("UIComponents/draggable/UIDragHandle"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _colors = require("HubStyleTokens/colors");

var _DragAndDrop = require("lead-flows-ui/constants/DragAndDrop");

var Draggable = (0, _reactDnd.DragSource)(_DragAndDrop.DragTypes.CONTACT_PROPERTY_OPTION_SORT, {
  beginDrag: function beginDrag(props) {
    return {
      id: props.option.cid,
      displayOrder: props.index
    };
  }
}, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
});
var Droppable = (0, _reactDnd.DropTarget)(_DragAndDrop.DragTypes.CONTACT_PROPERTY_OPTION_SORT, {
  hover: function hover(props, monitor) {
    var draggedValue = monitor.getItem().id;
    var droppedValue = props.option.cid;

    if (draggedValue !== droppedValue) {
      props.handleReorder(draggedValue, props.index);
    }
  }
}, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
});

var DraggableContactPropertyOptionsItem =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(DraggableContactPropertyOptionsItem, _React$PureComponent);
  (0, _createClass2.default)(DraggableContactPropertyOptionsItem, null, [{
    key: "propTypes",
    get: function get() {
      return {
        index: _react.default.PropTypes.number.isRequired,
        option: _react.default.PropTypes.object.isRequired,
        handleChange: _react.default.PropTypes.func.isRequired,
        handleDelete: _react.default.PropTypes.func.isRequired,
        handleReorder: _react.default.PropTypes.func.isRequired,
        handleBlur: _react.default.PropTypes.func.isRequired,
        handlePaste: _react.default.PropTypes.func.isRequired,
        connectDragSource: _react.default.PropTypes.func.isRequired,
        isDragging: _react.default.PropTypes.bool.isRequired,
        errorMessage: _react.default.PropTypes.string.isRequired
      };
    }
  }]);

  function DraggableContactPropertyOptionsItem() {
    var _this;

    (0, _classCallCheck2.default)(this, DraggableContactPropertyOptionsItem);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DraggableContactPropertyOptionsItem).call(this));
    _this.state = {
      onBlurEventHappened: false
    };
    _this.handleBlurEvent = _this.handleBlurEvent.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DraggableContactPropertyOptionsItem, [{
    key: "getLangKey",
    value: function getLangKey(path) {
      return "leadFlowEditor.contactProperties.createNew.errorMessage." + path;
    }
  }, {
    key: "handleBlurEvent",
    value: function handleBlurEvent() {
      this.setState({
        onBlurEventHappened: true
      });
      this.props.handleBlur();
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          option = _this$props.option,
          handleChange = _this$props.handleChange,
          handleDelete = _this$props.handleDelete,
          handlePaste = _this$props.handlePaste,
          errorMessage = _this$props.errorMessage,
          isDragging = _this$props.isDragging;
      var onBlurEventHappened = this.state.onBlurEventHappened;
      var draggingStyle = isDragging ? {
        opacity: 0
      } : {};
      var showErrorMessage = !(0, _underscore.isEmpty)(errorMessage);
      var errorMessageToShow = errorMessage;

      if (onBlurEventHappened === true && (0, _underscore.isEmpty)(option.label)) {
        showErrorMessage = true;
        errorMessageToShow = _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('emptyOption')
        });
      }

      return _react.default.createElement("div", {
        style: draggingStyle
      }, _react.default.createElement(_UIFlex.default, null, _react.default.createElement(_UIBox.default, {
        grow: 1
      }, _react.default.createElement(_UIFormControl.default, {
        error: showErrorMessage,
        validationMessage: showErrorMessage ? errorMessageToShow : ''
      }, _react.default.createElement(_UIDragHandle.default, null, _react.default.createElement(_UITextInput.default, {
        className: "p-left-6 m-top-2",
        value: option.value,
        onPaste: handlePaste,
        onChange: handleChange,
        onBlur: this.handleBlurEvent,
        ref: function focusAtCreation(input) {
          if (input != null && !onBlurEventHappened) {
            input.focus();
          }
        }
      })))), _react.default.createElement(_UIBox.default, {
        basis: "40px",
        grow: 0
      }, _react.default.createElement(_UIUnstyledButton.default, {
        className: "p-x-3 p-y-2",
        onClick: handleDelete,
        title: "delete"
      }, _react.default.createElement(_UIIcon.default, {
        name: "delete",
        color: _colors.CALYPSO
      })))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          connectDragSource = _this$props2.connectDragSource,
          connectDropTarget = _this$props2.connectDropTarget;
      return connectDragSource(connectDropTarget(this.renderContent()));
    }
  }]);
  return DraggableContactPropertyOptionsItem;
}(_react.default.PureComponent);

var _default = Droppable(Draggable(DraggableContactPropertyOptionsItem));

exports.default = _default;
module.exports = exports.default;